module.exports = __webpack_public_path__ + "img/jagopack-active.9e0df288.svg";